






























































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import numeral from 'numeral';
import quotationServices from '@/services/quotation-services';

@Component
export default class ComplaintList extends Vue {
    @Prop({ default: 0 })
    private quotationId!: number | string;

    @Prop({ default: () => ({}) })
    private quotation!: any;

    @Prop({ default: () => [] })
    private complaints!: any[];

    @Prop({ default: false })
    private canCreateComplain!: boolean;

    private localComplaints: any[] = [];
    private isFetching: boolean = false;
    private previewImageUrl: string = '';

    private get displayComplaints(): any[] {
        if (this.localComplaints && this.localComplaints.length > 0) {
            return this.localComplaints;
        }
        return this.complaints || [];
    }

    @Watch('complaints', { immediate: true })
    private onComplaintsChange(val: any[]) {
        if (val && val.length > 0) {
            this.localComplaints = val;
        }
    }

    private async created() {
        if (!this.complaints || this.complaints.length === 0) {
            await this.fetchComplaints();
        }
    }

    private async fetchComplaints() {
        const id = this.quotationId || (this.quotation && this.quotation.id);
        if (!id) return;
        this.isFetching = true;
        try {
            const res: any = await quotationServices.getComplaintsByQuotationId(id);
            if (res && res.data && res.data.status === 200) {
                const list = res.data.data || res.data.results || [];
                this.localComplaints = list;
                this.$emit('refresh-complaints', list);
            }
        } catch (e) {
            // silent
        } finally {
            this.isFetching = false;
        }
    }

    private formatCurrency(val: any): string {
        const num = Number(val) || 0;
        if (!num) return '0 đ';
        return numeral(num).format('0,0') + ' đ';
    }

    private getStatusBadgeClass(status: any): string {
        const s = Number(status);
        switch (s) {
            case 1:
                return 'label-warning'; // Chờ tiếp nhận
            case 2:
                return 'label-primary'; // Đang xử lý
            case 3:
                return 'label-success'; // Đã bồi thường
            case 4:
                return 'label-default'; // Từ chối
            case 0:
                return 'label-danger'; // Đã hủy
            default:
                return 'label-default';
        }
    }

    private getStatusLabel(status: any): string {
        const s = Number(status);
        switch (s) {
            case 1:
                return 'Chờ tiếp nhận';
            case 2:
                return 'Đang xử lý';
            case 3:
                return 'Đã bồi thường';
            case 4:
                return 'Từ chối khiếu nại';
            case 0:
                return 'Đã hủy';
            default:
                return 'Khác';
        }
    }

    private getResMethodLabel(method: any): string {
        const m = Number(method);
        switch (m) {
            case 1:
                return 'Bồi thường tiền mặt / ví';
            case 2:
                return 'Đổi trả hàng';
            case 3:
                return 'Phát bù hàng';
            case 4:
                return 'Khác';
            default:
                return 'Bồi thường';
        }
    }

    private hasReasonTags(c: any): boolean {
        return !!(c.is_miss_good || c.IsMissGood || c.is_broken || c.IsBroken || c.is_loss || c.IsLoss || c.is_option || c.IsOption || c.is_other || c.IsOther);
    }

    private getImages(c: any): string[] {
        if (c.images && Array.isArray(c.images)) {
            return c.images;
        }
        const imgStr = c.IMG || c.images;
        if (typeof imgStr === 'string' && imgStr.trim()) {
            return imgStr.split(';').map((s: string) => s.trim()).filter((s: string) => !!s);
        }
        return [];
    }

    private viewImage(url: string) {
        this.previewImageUrl = url;
    }
}
